<template>
  <div class="navItemDetails">
    <template v-if="selected">
      <div
        v-if="lastMessage"
        class="navItemDetails__message"
      >
        <p>{{ lastMessage.action }} - {{ lastMessage.content }} - {{ lastMessage.sender }}</p>
      </div>
    </template>
  </div>
</template>

<script>
import NavRecordsInterface from './NavRecordsInterface'
import { mapState } from 'vuex'

export default {
  name: "NavRecordsMessagesDetails",
  extends: NavRecordsInterface,
  computed: {
    ...mapState({
      messages: state => state.records.currentRecordMessages
    }),
    lastMessage() {
      if (this.messages && this.messages.length > 0) {
        return this.messages[this.messages.length - 1]
      }

      return null
    }
  },
  async mounted() {
    try {
      this.loading = true
      await this.$store.dispatch('records/getMessages')
      this.loading = false
    } catch (error) {
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.navItemDetails';

#{$c} {
  &__message {
    font-size: 21px;
    font-weight: 600;
    color: #207468;
  }
}
</style>